export default "__VITE_ASSET__BRPmyxBr__"